<template>
  <Transition name="fade">
    <Dialog
      v-if="quoteAcceptModal"
      title="Provide Quote"
      :showCloseButton="true"
      :showFooter="true"
      :showSaveButton="true"
      :showCancelButton="true"
      :sm="true"
      @closeEvent="closeEvent"
      @cancelEvent="closeEvent"
      @saveEvent="() => saveQuotePrice()"
      :saveButtonProps="{
        disabled: !isQuoteFormValid,
      }"
    >
      <template #modal-content>
        <form id="quoteForm">
          <div class="flex flex-col gap-2 w-full">
            <label for="from-date">Provide Quote:</label>
            <textarea
              v-model="quote.quote_text"
              rows="3"
              placeholder="Enter quote text"
              class="w-full px-3 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              required
              minlength="3"
            ></textarea>
          </div>
        </form>
      </template>
    </Dialog>
  </Transition>
</template>
<script setup lang="ts">
import Dialog from '@/components/Shared/Dialog.vue';
import { showToast } from '@/composables/swal';
import { handleResponseException, http } from '@/interceptors/axiosRequestInterceptor';
import { DashboardItem } from '@/models';
import { useMainStore } from '@/store/index';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
const store = useMainStore();
const { loading } = storeToRefs(store);
const quoteAcceptModal = ref<boolean>(false);
const quote = ref<{
  quote_text: string;
  quote_order_id: number | string;
  quote_order_no: string;
}>({
  quote_text: '',
  quote_order_id: '',
  quote_order_no: '',
});
const props = defineProps<{
  row: any;
}>();
const emits = defineEmits(['onQuoteProvided']);
const closeEvent = () => {
  quoteAcceptModal.value = false;
};
const provideQuotePrice = () => {
  const order = (props.row as DashboardItem).order;
  quote.value.quote_order_id = order.id;
  quote.value.quote_order_no = order.order_no;
  quote.value.quote_text = '';
  quoteAcceptModal.value = true;
};

const isQuoteFormValid = computed(() => quote.value.quote_text.length > 3);
const saveQuotePrice = async (): Promise<boolean> => {
  if (quote.value.quote_text === '') {
    showToast('please provide quote text.', 'error');
    return false;
  }
  loading.value = true;
  try {
    const resp = await http.post(`/save-quote-price`, quote.value);
    loading.value = false;
    quoteAcceptModal.value = false;
    if (resp.data.success) {
      quote.value.quote_order_id = '';
      quote.value.quote_order_no = '';
      quote.value.quote_text = '';
      emits('onQuoteProvided');
      showToast(resp.data.message, 'success');
    }
  } catch (e: any) {
    loading.value = false;
    quoteAcceptModal.value = false;
    handleResponseException(e);
  }
  return true;
};

onMounted(() => {
  provideQuotePrice();
});
</script>
<style lang="sass" scoped></style>
